import * as React from 'react';
import './LogIn.css';

import {
    GetPasswordValidationStateLength,
    GetPasswordValidationStateUpperCase,
    GetPasswordValidationStateLowerCase,
    GetPasswordValidationStateNumber,
    GetPasswordValidationStateSpecialChar
} from './PasswordValidation';
interface IProps {
    Password?: string;
    ClassNames?: string;
}

export const PasswordHelpBlock = ({ Password, ClassNames }: IProps) => {
    return (
        <div className={`password-help-block ${ClassNames}`}>
            <div className={GetPasswordValidationStateLength(Password) ? 'ok' : ''}>
                <span className="radio-info" />Minimalna liczba wymaganych znaków: 8
                                            </div>
            <div className={GetPasswordValidationStateUpperCase(Password) ? 'ok' : ''}>
                <span className="radio-info" />Zawiera dużą literę
                                            </div>
            <div className={GetPasswordValidationStateLowerCase(Password) ? 'ok' : ''}>
                <span className="radio-info" />Zawiera małą literę
                                            </div>
            <div className={GetPasswordValidationStateNumber(Password) ? 'ok' : ''}>
                <span className="radio-info" />Zawiera liczbę
                                            </div>
            <div className={GetPasswordValidationStateSpecialChar(Password) ? 'ok' : ''}>
                <span className="radio-info" />Zawiera znak specjalny
                                            </div>
        </div>
    )

}




// WEBPACK FOOTER //
// ./src/components/Login/PasswordHelpBlock.tsx